import openModalAction from 'modules/modal/actions/open'
import { MODAL_ID } from 'modules/modal/constants/index.cjs'

function openConfirmModalAction (data) {
  return openModalAction(MODAL_ID.CONFIRM, data)
}

export default openConfirmModalAction
